import * as React from "react";

import { useGetDirectoryUsersQuery } from "@/api/users-admin";

export const useUserDirectory = (userIds: Array<string | null>) => {
  const ids = React.useMemo(() => [...new Set(userIds.filter((id): id is string => Boolean(id)))].sort(), [userIds]);
  const { data: users = [] } = useGetDirectoryUsersQuery(ids, { skip: ids.length === 0 });
  return React.useMemo(() => new Map(users.map(user => [user.id, user])), [users]);
};
